import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

import NoPaymentsIMG from "../../../../assets/images/payments/no-payments-figure.png";

const NoPaidUsersFigure = () => {
  const { t } = useTranslation();

  return (
    <Box component="figure" sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "24px" }}>
      <img src={NoPaymentsIMG} width="240px" height="180px" />
      <Box component="figcaption" sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
        <Typography
          component="h3"
          sx={{
            color: "var(--Dark---1000, #111)",
            textAlign: "center",
            fontFamily: "Montserrat",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "32px",
          }}
        >
          {t("pages.payment.overview.dashboard.noPaidUsers")}
        </Typography>
        <Typography
          component="p"
          sx={{
            color: "var(--Gray-Gray-700, #5E6278)",
            textAlign: "center",
            fontFamily: "Montserrat",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "24px",
          }}
        >
          {t("pages.payment.overview.dashboard.onceUsers")}
        </Typography>
      </Box>
    </Box>
  );
};

export default NoPaidUsersFigure;
